module.exports = __webpack_public_path__ + "media/application/images/telegram-4-27bffba0f48b70f4011f67858e5a863e.svg";